var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9.984 3.984L12 6h8.016c1.078 0 1.969.938 1.969 2.016V18c0 1.078-.891 2.016-1.969 2.016H3.985c-1.078 0-1.969-.938-1.969-2.016V6c0-1.078.891-2.016 1.969-2.016h6z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }